import { IClassname } from '@/lib/shared/model/classname';

export const TableTennis = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25913 11.1643C6.69295 12.7955 6.50029 14.5331 6.69537 16.2488C6.89045 17.9645 7.46829 19.6145 8.38625 21.0771L2.75575 26.7076C2.51618 26.9472 2.38159 27.2722 2.38159 27.611C2.38159 27.9499 2.51618 28.2749 2.75575 28.5145L4.56272 30.3215C4.80237 30.5611 5.12735 30.6957 5.46621 30.6957C5.80507 30.6957 6.13005 30.5611 6.3697 30.3215L12.0002 24.6897C13.7419 25.7851 15.7455 26.3932 17.8022 26.4507C19.8589 26.5081 21.8934 26.0128 23.6935 25.0163C25.4936 24.0198 26.9934 22.5587 28.0366 20.7852C29.0798 19.0118 29.6282 16.991 29.6245 14.9335C29.6209 12.876 29.0653 10.8571 28.0159 9.0874C26.9664 7.31768 25.4614 5.86189 23.6578 4.8718C21.8541 3.88172 19.8179 3.3936 17.7614 3.45833C15.705 3.52306 13.7035 4.13828 11.9657 5.23983"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.83862 12.7183L20.359 26.2386"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.38135 5.13795C2.38135 6.15472 2.78526 7.12985 3.50423 7.84882C4.22319 8.56779 5.19832 8.9717 6.2151 8.9717C7.23187 8.9717 8.207 8.56779 8.92597 7.84882C9.64494 7.12985 10.0488 6.15472 10.0488 5.13795C10.0488 4.12118 9.64494 3.14605 8.92597 2.42708C8.207 1.70811 7.23187 1.3042 6.2151 1.3042C5.19832 1.3042 4.22319 1.70811 3.50423 2.42708C2.78526 3.14605 2.38135 4.12118 2.38135 5.13795Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
